import { ColorSwatch as MantineColorSwatch } from '@mantine/core'
import { ColorSwatchProps } from './color-swatch.types'

export const ColorSwatch = ({ ...props }: ColorSwatchProps) => <MantineColorSwatch {...props} />
